import React, { useEffect, useState } from "react";
import {
  getFormContent,
  getSingleSurvey,
  updateFormContent,
  surveyResultPreview,
  sharePreviewLink,
  addFormContent,
  imageUpload,
} from "../../../api/services/services";
import { useNavigate, useParams } from "react-router-dom";
import { Button, Snackbar, Box, Typography, Grid, CircularProgress, IconButton, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Paper, Divider } from "@mui/material";
import MuiAlert from "@mui/material/Alert";
import moment from "moment";
import generatePDF, { Resolution, Margin } from "react-to-pdf";
import html2pdf from "html2pdf.js";
import { Bucket } from "../../../api/config/apiConfig";
import ContactDetailField from "../../molecules/ContactDetailField";
import TextArea from "../../atoms/Textarea";
import Input from "../../atoms/Input";
import LoadingModal from "../../molecules/LoadingModal";
import MySignatureCanvas from "../../molecules/signature_canvas";
import ShareWithClientsModal from "../../molecules/ShareWithClients";
import PrintComponent from "../PrintComponent";
import WorksheetImportDownload from "./ClientSide/download";
import DynamicText from "../../molecules/DynamicText";
import editIcn from "../../../imgs/edit.png";
import trashIcn from "../../../imgs/trash.png";
import PremiumPageLayout from "../../templates/PremiumPageLayout";
import PremiumCard from "../../molecules/PremiumCard";
import SectionHeader from "../../molecules/SectionHeader";
import DescriptionIcon from "@mui/icons-material/Description";
import NoteAltIcon from "@mui/icons-material/NoteAlt";
import AssignmentIcon from "@mui/icons-material/Assignment";
import BusinessIcon from "@mui/icons-material/Business";
import ScaleIcon from "@mui/icons-material/Scale";
import EventIcon from "@mui/icons-material/Event";
import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import CancelIcon from "@mui/icons-material/Cancel";
import ShareIcon from "@mui/icons-material/Share";
import PrintIcon from "@mui/icons-material/Print";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import { sendSuperAdminVerificationForEdit } from "../PrebidAgreement/creation/service";
import SuperAdminVerifationModal from "../../molecules/SuperAdminVerifationModal";

const WorksheetImportPage = () => {
  const { surveyId, id, flg, org } = useParams();
  const [surveyData, setSurveyData] = useState(null);
  const navigate = useNavigate();

  const [formContentId, setFormContentId] = useState("");
  const [isEdit, setIsEdit] = useState(flg == "1" ? true : false);

  const [isLoading, setIsLoading] = useState(false);
  const [formContent, setFormContent] = useState({
    clientName: "",
    clientEmail: "",
    clientSign: "",
    organization: org,
    deliveryAddres: "",
    fileNo: "",
    contactNo: "",
    fax: "",
    email: "",
    entitlement1: "",
    estimatedWeight: "",
    actualWeight: "",
    entitlement2: "",
    estimatedVolume: "",
    actualVolume: "",
    deliveryStartedDate: "",
    deliveryCompletedDate: "",
    shiftingStartedDate: "",
    shiftingCompletedDate: "",
    wareHouseInDate: "",
    wareHouseOutDate: "",
    shipmentDate: "",
    originDestination: "",
    shipmentMode: "",
    bolAWBNo: "",
    containerNo: "",
    vessel: "",
    ETDbyETA: "",
    ETA: "",
    airline: "",
    flightNo: "",
    remarks: "",
    managerSign: "",
    assistOperSign: "",
  });

  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");

  const [isShare, setIsShare] = useState(false);

  const [mediaKeysToSend, setMediaKeysToSend] = useState([]);
  const [mediaKeysToRemove, setMediaKeysToRemove] = useState([]);

  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const [isSignCanvas, setSignCanvas] = useState(false);
  const [whichSign, setWhichSign] = useState("");

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  //
  const getSurveyPreview = () => {
    surveyResultPreview(surveyId)
      .then((response) => {
        setSurveyData(response?.data?.data?.surveyDetail);
        let values = { ...formContent };
        values.originAddress = `${response?.data?.data?.surveyDetail?.loadPlaceStAddress}, ${response?.data?.data?.surveyDetail?.loadPlaceCity}, ${response?.data?.data?.surveyDetail?.loadPlaceCountry}`;
        values.destinationAddress = `${response?.data?.data?.surveyDetail?.unloadPlaceStAddress}, ${response?.data?.data?.surveyDetail?.unloadPlaceCity}, ${response?.data?.data?.surveyDetail?.unloadPlaceCountry}`;
        values.deliveryAddres = `${response?.data?.data?.surveyDetail?.unloadPlaceStAddress}, ${response?.data?.data?.surveyDetail?.unloadPlaceCity}, ${response?.data?.data?.surveyDetail?.unloadPlaceCountry}`;
        values.customerName = `${response?.data?.data?.surveyDetail?.name}`;
        values.clientEmail = `${response?.data?.data?.surveyDetail?.email}`;
        values.fileNo = `${response?.data?.data?.surveyDetail?.id}`;
        values.email = `${response?.data?.data?.surveyDetail?.email}`;
        values.contactNo = `${response?.data?.data?.surveyDetail?.phone}`;

        values.originDestination = `${values.originAddress} / ${values.destinationAddress}`;

        let totalWeight = 0;
        let totalCbm = 0;
        response?.data?.data?.roomWiseCalculation?.map((cat, index) => {
          totalWeight = totalWeight + cat?.totalWeightKg;
          totalCbm = totalCbm + cat?.totalCbm;
        });

        values.estimatedWeight = totalWeight;
        values.estimatedVolume = totalCbm;

        setFormContent(values);
      })
      .catch((error) => {
        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }
      });
  };

  //
  const getSurvey = () => {
    getSingleSurvey(surveyId)
      .then((response) => {
        if (response?.data?.data?.status == "submitted") getSurveyPreview();
        else {
          setSurveyData(response?.data?.data);
          let values = { ...formContent };
          values.originAddress = `${response?.data?.data?.loadPlaceStAddress}, ${response?.data?.data?.loadPlaceCity}, ${response?.data?.data?.loadPlaceCountry}`;
          values.destinationAddress = `${response?.data?.data?.unloadPlaceStAddress}, ${response?.data?.data?.unloadPlaceCity}, ${response?.data?.data?.unloadPlaceCountry}`;
          values.deliveryAddres = `${response?.data?.data?.unloadPlaceStAddress}, ${response?.data?.data?.unloadPlaceCity}, ${response?.data?.data?.unloadPlaceCountry}`;
          values.customerName = `${response?.data?.data?.name}`;
          values.clientEmail = `${response?.data?.data?.email}`;
          values.fileNo = `${response?.data?.data?.id}`;
          values.email = `${response?.data?.data?.email}`;
          values.contactNo = `${response?.data?.data?.phone}`;

          values.originDestination = `${values.originAddress} / ${values.destinationAddress}`;
          values.organization = org;

          setFormContent(values);
        }
      })
      .catch((error) => {
        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }
      });
  };

  //
  const addContent = () => {
    setIsLoading(true);
    const body = {
      formId: id,
      surveyId: surveyId,
      content: formContent,
      mediaKeys: mediaKeysToSend,
      removedMediaKeys: [],
    };
    addFormContent(body)
      .then(() => {
        setSnackbarMessage(
          "Worksheet Import Form has been added successfully!"
        );
        setOpenSnackbar(true);

        setTimeout(() => {
          navigate(-1);
          setIsLoading(false);
        }, 1000);
        setMediaKeysToSend([]);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }

        setIsLoading(false);
      });
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}/${month}/${year}`;
  };

  //
  const updateContent = () => {
    setIsLoading(true);
    const body = {
      formId: id,
      surveyId: surveyId,
      content: formContent,
      mediaKeys: mediaKeysToSend,
      removedMediaKeys: mediaKeysToRemove,
    };
    updateFormContent(body, formContentId)
      .then((res) => {
        setSnackbarMessage(
          "Worksheet Import Form has been updated successfully!"
        );
        setOpenSnackbar(true);
        getContent();
        setIsEdit(false);

        setIsLoading(false);
        setMediaKeysToSend([]);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }

        setIsLoading(false);
      });
  };

  //
  const getContent = () => {
    setIsLoading(true);
    setMediaKeysToSend([]);
    getFormContent(id, surveyId)
      .then((res) => {
        setFormContentId(res.data.data.uuid);
        setFormContent(res.data.data.content);
        setIsLoading(false);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }

        setIsLoading(false);
      });
  };

  useEffect(() => {
    console.log(org);
    if (flg == "1") getSurvey();
    else getContent();
  }, []);

  const [show, setShow] = useState(false);
  const options = {
    // resolution: Resolution.HIGH,
    page: {
      // margin is in MM, default is Margin.NONE = 0
      margin: Margin.SMALL,
      // default is 'A4'
      format: "letter",
      // default is 'portrait'
      orientation: "portrait",
    },
    canvas: {
      // default is 'image/jpeg' for better size performance
      mimeType: "image/png",
      qualityRatio: 1,
    },
    overrides: {
      pdf: {
        compress: true,
      },
    },
  };

  //
  const generatePdf = () => {
    if (window.innerWidth <= 768) {
      if (typeof setSnackbarMessage !== "undefined" && typeof setOpenSnackbar !== "undefined") {
        setSnackbarMessage("For a good experience, please use a desktop screen");
        setOpenSnackbar(true);
      } else {
        alert("For a good experience, please use a desktop screen");
      }
      return;
    }

    setShow(true);

    setTimeout(() => {
      const content = document.getElementById("content-to-convert"); // Replace with the ID of the element you want to convert to PDF

      const currentDateTime = new Date();
      const filename = `survey_${currentDateTime.toISOString()}.pdf`;

      const pdfOptions = {
        margin: 5,
        filename: filename,
        image: { type: "jpeg", quality: 0.98 },
        html2canvas: { scale: 2 },
        jsPDF: {
          unit: "mm",
          format: "a4",
          orientation: "portrait",
        }, // Set the page size here
      };

      let temp = html2pdf().from(content).set(pdfOptions).outputPdf();
      temp.save(filename);

      setShow(false);
    }, 3500);
  };

  const [downloadText, setDownloadText] = useState("download");

  const getTargetElement = () => document.getElementById("content-id");

  //
  const shareWithClient = (data) => {
    let ems = [];
    let emsInd = 0;
    data.map((dt) => {
      if (dt.trim().length != 0) {
        ems[emsInd] = dt;
        emsInd++;
      }
    });

    setIsLoading(true);
    const body = {
      surveyId: surveyId,
      formId: id,
      emails: ems,
      formRoute: "worksheet-import-preview",
    };
    sharePreviewLink(body)
      .then(() => {
        setSnackbarMessage(
          "Worksheet Import Form have been shared with the respective emails successfully!"
        );
        setOpenSnackbar(true);

        setIsLoading(false);
        setIsShare(false);
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }

        setIsLoading(false);
      });
  };

  const printAction = () => {
    const PAGE_HEIGHT = 1045;
    const printElement = document.getElementById("print-component");
    if (printElement) {
      printElement.classList.add("temp-class-for-height");
      const height = printElement.clientHeight - 500;
      const numberOfPage = Math.ceil(height / PAGE_HEIGHT);
      const heightWithSingleHeader = numberOfPage * PAGE_HEIGHT;
      let requiredHeight = heightWithSingleHeader;
      if (numberOfPage > 1) {
        const headerHeight =
          printElement.getElementsByTagName("thead")?.[0]?.clientHeight;
        const footerHeight =
          printElement.getElementsByTagName("tfoot")?.[0]?.clientHeight;
        requiredHeight -= (numberOfPage - 1) * (headerHeight + footerHeight);
      }
      printElement.style.height = `${requiredHeight}px`;
      printElement.classList.remove("temp-class-for-height");
    }
    window.print();
    if (printElement) {
      printElement.style.height = `auto`;
    }
  };

  const [uploadText1, setUploadText1] = useState("Upload Sign");
  const [uploadText2, setUploadText2] = useState("Upload Sign");

  //
  const uploadFile = async (file) => {
    setIsLoading(true);

    handleOpen();
    if (whichSign == "manager") setUploadText1("Uploading...");
    if (whichSign == "assist") setUploadText2("Uploading...");

    const fd = new FormData();
    fd.append("image", file);

    imageUpload(fd)
      .then((res) => {
        let values = { ...formContent };
        let dlt = [...mediaKeysToRemove];
        if (whichSign == "manager") {
          if (formContent.managerSign?.trim()?.length != 0)
            dlt.push(formContent.managerSign);
          values.managerSign = res?.data?.data?.key;
        }
        if (whichSign == "assist") {
          if (formContent.assistOperSign?.trim()?.length != 0)
            dlt.push(formContent.assistOperSign);
          values.assistOperSign = res?.data?.data?.key;
        }

        setMediaKeysToRemove(dlt);
        setFormContent(values);

        let md = [...mediaKeysToSend];
        md.push(res?.data?.data?.key);
        setMediaKeysToSend(md);

        setIsLoading(false);
        setUploadText1("Upload Sign");
        setUploadText2("Upload Sign");
        handleClose();
      })
      .catch((error) => {
        setSnackbarMessage(error?.response?.data?.message);
        setOpenSnackbar(true);

        if (error?.response?.data?.statusCode == 401) {
          localStorage.clear();
          window.location.pathname = "/login";
        }

        setUploadText1("Upload Sign");
        setUploadText2("Upload Sign");

        setIsLoading(false);
        handleClose();
      });
  };

  const [isVerified, setIsVerified] = useState(false);
  const [isEditLoading, setIsEditLoading] = useState(false);

  const sendEditRequestToAdmin = () => {
    setIsEditLoading(true);
    sendSuperAdminVerificationForEdit()
      .then((response) => {
        setIsVerified(true);
        setIsEditLoading(false);
      })
      .catch((error) => {
        setIsVerified(false);
        setIsEditLoading(false);
      });
  };

  const pageActions = (
    <>
      {!isEdit && (
        <Button
          variant="contained"
          onClick={() => sendEditRequestToAdmin()}
          disabled={isEditLoading}
          startIcon={<NoteAltIcon />}
           sx={{ 
            textTransform: "none", 
            borderRadius: "var(--radius-md)", 
            padding: "10px 24px",
            fontWeight: 700,
            backgroundColor: "var(--primary-color)",
            boxShadow: "0 4px 12px rgba(79, 70, 229, 0.2)",
            '&:hover': { backgroundColor: 'var(--primary-hover)' }
          }}
        >
          Edit
        </Button>
      )}

      {!isEdit && (
        <Button
          variant="outlined"
          onClick={() => setIsShare(true)}
          disabled={isLoading}
           sx={{ 
            textTransform: "none", 
            borderRadius: "var(--radius-md)", 
            padding: "10px 24px",
            fontWeight: 700,
            border: "1px solid var(--glass-border)",
            color: "var(--text-main)",
            '&:hover': { background: 'var(--bg-color)', borderColor: 'var(--primary-color)' }
          }}
        >
          Share
        </Button>
      )}

      {isEdit && flg == "2" && (
        <Button
          variant="outlined"
          color="error"
          onClick={() => {
            getContent();
            setIsEdit(false);
          }}
          disabled={isLoading}
           sx={{ textTransform: "none", borderRadius: "var(--radius-md)", fontWeight: 700, padding: "10px 24px", border: "1px solid" }}
        >
          Cancel
        </Button>
      )}

      {isEdit && (
        <Button
          variant="contained"
          onClick={() => {
            if (flg == "1") addContent();
            else updateContent();
          }}
          disabled={isLoading}
           sx={{ 
            textTransform: "none", 
            borderRadius: "var(--radius-md)", 
            padding: "10px 32px",
            fontWeight: 700,
            backgroundColor: "var(--primary-color)",
            boxShadow: "0 4px 12px rgba(79, 70, 229, 0.3)",
            '&:hover': { backgroundColor: 'var(--primary-hover)' }
          }}
        >
          Save
        </Button>
      )}

      {!isEdit && (
        <Button
          variant="contained"
          onClick={() => {
            if (window.innerWidth <= 768) {
      if (typeof setSnackbarMessage !== "undefined" && typeof setOpenSnackbar !== "undefined") {
        setSnackbarMessage("For a good experience, please use a desktop screen");
        setOpenSnackbar(true);
      } else {
        alert("For a good experience, please use a desktop screen");
      }
      return;
    }
            var tempTitle = document.title;
            document.title = `Worksheet-${
              formContent?.clientName
            }-${moment(new Date()).format("DD.MM.YYYY")}`;

            window.print();
            document.title = tempTitle;
          }}
          disabled={isLoading}
          startIcon={<DescriptionIcon />}
           sx={{ 
            textTransform: "none", 
            borderRadius: "var(--radius-md)", 
            padding: "10px 24px",
            fontWeight: 700,
            backgroundColor: "var(--text-main)",
             boxShadow: "0 4px 12px rgba(15, 23, 42, 0.2)",
             '&:hover': { backgroundColor: '#000' }
          }}
        >
          Save as PDF
        </Button>
      )}
    </>
  );

  return (
    <>
      <PremiumPageLayout
        title="Worksheet"
        actions={pageActions}
        onBack={() => navigate(-1)}
      >
        <SectionHeader title="Client & Job Details" icon={<BusinessIcon />} />
        <PremiumCard sx={{ marginBottom: "32px", padding: "24px" }}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <ContactDetailField
                label="Name"
                isEdit={isEdit}
                type="text"
                value={formContent?.customerName}
                onChange={(e) =>
                  setFormContent({
                    ...formContent,
                    customerName: e.target.value,
                  })
                }
                disabled
              />
              <ContactDetailField
                label="Organization"
                isEdit={isEdit}
                type="text"
                value={formContent?.organization}
                onChange={(e) =>
                  setFormContent({
                    ...formContent,
                    organization: e.target.value,
                  })
                }
              />
              <ContactDetailField
                label="Delivery Address"
                isEdit={isEdit}
                type="text"
                value={formContent?.deliveryAddres}
                onChange={(e) =>
                  setFormContent({
                    ...formContent,
                    deliveryAddres: e.target.value,
                  })
                }
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <ContactDetailField
                label="File No."
                isEdit={isEdit}
                type="text"
                value={formContent?.fileNo}
                disabled={true}
              />
              <ContactDetailField
                label="Contact No"
                isEdit={isEdit}
                type="number"
                value={
                  formContent?.contactNo != "null" &&
                  formContent?.contactNo != undefined
                    ? formContent?.contactNo
                    : ""
                }
                onChange={(e) =>
                  setFormContent({
                    ...formContent,
                    contactNo: e.target.value,
                  })
                }
              />
              <ContactDetailField
                label="Fax"
                isEdit={isEdit}
                type="number"
                value={formContent?.fax}
                onChange={(e) =>
                  setFormContent({
                    ...formContent,
                    fax: e.target.value,
                  })
                }
              />
              <ContactDetailField
                label="Email"
                isEdit={isEdit}
                type="text"
                value={formContent?.email}
                onChange={(e) =>
                  setFormContent({
                    ...formContent,
                    email: e.target.value,
                  })
                }
              />
            </Grid>
          </Grid>
        </PremiumCard>
        <Grid container spacing={4}>
          <Grid item xs={12} md={6}>
            <SectionHeader title="Cargo Details" icon={<ScaleIcon />} />
            <PremiumCard sx={{ padding: "24px", height: "100%" }}>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <ContactDetailField
                    label="Entitlement"
                    isEdit={isEdit}
                    type="text"
                    value={formContent?.entitlement1}
                    onChange={(e) => setFormContent({ ...formContent, entitlement1: e.target.value })}
                  />
                </Grid>
                <Grid item xs={6}>
                  <ContactDetailField
                    label="Est. Weight"
                    isEdit={isEdit}
                    type="text"
                    value={formContent?.estimatedWeight}
                    onChange={(e) => setFormContent({ ...formContent, estimatedWeight: e.target.value })}
                  />
                </Grid>
                <Grid item xs={6}>
                  <ContactDetailField
                    label="Act. Weight"
                    isEdit={isEdit}
                    type="text"
                    value={formContent?.actualWeight}
                    onChange={(e) => setFormContent({ ...formContent, actualWeight: e.target.value })}
                  />
                </Grid>
                <Grid item xs={6}>
                  <ContactDetailField
                    label="Est. Volume"
                    isEdit={isEdit}
                    type="text"
                    value={formContent?.estimatedVolume}
                    onChange={(e) => setFormContent({ ...formContent, estimatedVolume: e.target.value })}
                  />
                </Grid>
                <Grid item xs={6}>
                  <ContactDetailField
                    label="Act. Volume"
                    isEdit={isEdit}
                    type="text"
                    value={formContent?.actualVolume}
                    onChange={(e) => setFormContent({ ...formContent, actualVolume: e.target.value })}
                  />
                </Grid>
              </Grid>
            </PremiumCard>
          </Grid>

          <Grid item xs={12} md={6}>
            <SectionHeader title="Operations Dates" icon={<EventIcon />} />
            <PremiumCard sx={{ padding: "24px", height: "100%" }}>
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <ContactDetailField
                    label="Pack Started"
                    isEdit={isEdit}
                    type="date"
                    value={formContent?.deliveryStartedDate}
                    onChange={(e) => setFormContent({ ...formContent, deliveryStartedDate: e.target.value })}
                  />
                </Grid>
                <Grid item xs={6}>
                  <ContactDetailField
                    label="Pack Completed"
                    isEdit={isEdit}
                    type="date"
                    value={formContent?.deliveryCompletedDate}
                    onChange={(e) => setFormContent({ ...formContent, deliveryCompletedDate: e.target.value })}
                  />
                </Grid>
                <Grid item xs={6}>
                  <ContactDetailField
                    label="Shift Started"
                    isEdit={isEdit}
                    type="date"
                    value={formContent?.shiftingStartedDate}
                    onChange={(e) => setFormContent({ ...formContent, shiftingStartedDate: e.target.value })}
                  />
                </Grid>
                <Grid item xs={6}>
                  <ContactDetailField
                    label="Shift Completed"
                    isEdit={isEdit}
                    type="date"
                    value={formContent?.shiftingCompletedDate}
                    onChange={(e) => setFormContent({ ...formContent, shiftingCompletedDate: e.target.value })}
                  />
                </Grid>
                <Grid item xs={6}>
                  <ContactDetailField
                    label="Warehouse In"
                    isEdit={isEdit}
                    type="date"
                    value={formContent?.wareHouseInDate}
                    onChange={(e) => setFormContent({ ...formContent, wareHouseInDate: e.target.value })}
                  />
                </Grid>
                <Grid item xs={6}>
                  <ContactDetailField
                    label="Warehouse Out"
                    isEdit={isEdit}
                    type="date"
                    value={formContent?.wareHouseOutDate}
                    onChange={(e) => setFormContent({ ...formContent, wareHouseOutDate: e.target.value })}
                  />
                </Grid>
              </Grid>
            </PremiumCard>
          </Grid>
        </Grid>

        <SectionHeader title="Logistics & Shipment" icon={<LocalShippingIcon />} sx={{ mt: 4 }} />
        <PremiumCard sx={{ marginBottom: "32px", padding: "24px" }}>
          <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
              <ContactDetailField
                label="Origin / Dest"
                isEdit={isEdit}
                type="text"
                value={formContent?.originDestination}
                onChange={(e) => setFormContent({ ...formContent, originDestination: e.target.value })}
              />
              <ContactDetailField
                label="BOL/AWB No."
                isEdit={isEdit}
                type="text"
                value={formContent?.bolAWBNo}
                onChange={(e) => setFormContent({ ...formContent, bolAWBNo: e.target.value })}
              />
              <ContactDetailField
                label="Container No."
                isEdit={isEdit}
                type="text"
                value={formContent?.containerNo}
                onChange={(e) => setFormContent({ ...formContent, containerNo: e.target.value })}
              />
              <ContactDetailField
                label="Vessel"
                isEdit={isEdit}
                type="text"
                value={formContent?.vessel}
                onChange={(e) => setFormContent({ ...formContent, vessel: e.target.value })}
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <ContactDetailField
                label="Shipment Date"
                isEdit={isEdit}
                type="date"
                value={formContent?.shipmentDate}
                onChange={(e) => setFormContent({ ...formContent, shipmentDate: e.target.value })}
              />
              <Grid container spacing={2}>
                <Grid item xs={6}>
                  <ContactDetailField
                    label="ETD"
                    isEdit={isEdit}
                    type="date"
                    value={formContent?.ETDbyETA}
                    onChange={(e) => setFormContent({ ...formContent, ETDbyETA: e.target.value })}
                  />
                </Grid>
                <Grid item xs={6}>
                  <ContactDetailField
                    label="ETA"
                    isEdit={isEdit}
                    type="date"
                    value={formContent?.ETA}
                    onChange={(e) => setFormContent({ ...formContent, ETA: e.target.value })}
                  />
                </Grid>
              </Grid>
              <ContactDetailField
                label="Airline"
                isEdit={isEdit}
                type="text"
                value={formContent?.airline}
                onChange={(e) => setFormContent({ ...formContent, airline: e.target.value })}
              />
              <ContactDetailField
                label="Flight No."
                isEdit={isEdit}
                type="text"
                value={formContent?.flightNo}
                onChange={(e) => setFormContent({ ...formContent, flightNo: e.target.value })}
              />
            </Grid>
          </Grid>
        </PremiumCard>

        <SectionHeader title="Remarks & Instructions" icon={<AssignmentIcon />} />
        <PremiumCard sx={{ marginBottom: "32px", padding: "24px" }}>
          <DynamicText
            label=""
            textAreaLabel="Remarks"
            isEdit={isEdit}
            value={formContent?.remarks}
            onChange={(e) => setFormContent({ ...formContent, remarks: e.target.value })}
          />
        </PremiumCard>

        <Grid container spacing={4} sx={{ mt: 4 }}>
          <Grid item xs={12} md={6}>
            <Box sx={{ textAlign: "center" }}>
              <Box sx={{ height: "100px", display: "flex", alignItems: "center", justifyContent: "center", borderBottom: "2px solid #e2e8f0", mb: 1 }}>
                {formContent?.managerSign?.trim()?.length > 0 ? (
                  <Box sx={{ position: "relative" }}>
                    <img src={`${Bucket}${formContent?.managerSign}`} height={80} style={{ objectFit: "contain" }} />
                    {isEdit && (
                      <Box sx={{ position: "absolute", top: -10, right: -40, display: "flex", gap: 1 }}>
                        <IconButton size="small" onClick={() => { setWhichSign("manager"); setSignCanvas(true); }} sx={{ backgroundColor: "#fff", boxShadow: 1 }}>
                          <EditIcon fontSize="small" />
                        </IconButton>
                        <IconButton 
                          size="small" 
                          color="error" 
                          sx={{ backgroundColor: "#fff", boxShadow: 1 }}
                          onClick={() => {
                            let values = { ...formContent };
                            values.managerSign = "";
                            setFormContent(values);
                          }}
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </Box>
                    )}
                  </Box>
                ) : (
                  isEdit && (
                    <Button variant="outlined" startIcon={<BorderColorIcon />} onClick={() => { setWhichSign("manager"); setSignCanvas(true); }}>
                      Upload Manager Sign
                    </Button>
                  )
                )}
              </Box>
              <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>Manager Operations</Typography>
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Box sx={{ textAlign: "center" }}>
              <Box sx={{ height: "100px", display: "flex", alignItems: "center", justifyContent: "center", borderBottom: "2px solid #e2e8f0", mb: 1 }}>
                {formContent?.assistOperSign?.trim()?.length > 0 ? (
                  <Box sx={{ position: "relative" }}>
                    <img src={`${Bucket}${formContent.assistOperSign}`} height={80} style={{ objectFit: "contain" }} />
                    {isEdit && (
                      <Box sx={{ position: "absolute", top: -10, right: -40, display: "flex", gap: 1 }}>
                        <IconButton size="small" onClick={() => { setWhichSign("assist"); setSignCanvas(true); }} sx={{ backgroundColor: "#fff", boxShadow: 1 }}>
                          <EditIcon fontSize="small" />
                        </IconButton>
                        <IconButton 
                          size="small" 
                          color="error" 
                          sx={{ backgroundColor: "#fff", boxShadow: 1 }}
                          onClick={() => {
                            let values = { ...formContent };
                            values.assistOperSign = "";
                            setFormContent(values);
                          }}
                        >
                          <DeleteIcon fontSize="small" />
                        </IconButton>
                      </Box>
                    )}
                  </Box>
                ) : (
                  isEdit && (
                    <Button variant="outlined" startIcon={<BorderColorIcon />} onClick={() => { setWhichSign("assist"); setSignCanvas(true); }}>
                      Upload Assistant Sign
                    </Button>
                  )
                )}
              </Box>
              <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>Assistant Operations</Typography>
            </Box>
          </Grid>
        </Grid>

        <LoadingModal open={isLoading} handleClose={() => setIsLoading(false)} />

        {isSignCanvas && (
          <MySignatureCanvas
            open={isSignCanvas}
            onClose={() => setSignCanvas(false)}
            onSuccess={(file) => !isLoading && uploadFile(file)}
          />
        )}

        {isVerified && (
          <SuperAdminVerifationModal
            open={isVerified}
            onClose={() => setIsVerified(false)}
            onSuccess={() => {
              setIsEdit(true);
              setIsVerified(false);
            }}
            onError={() => {
              setSnackbarMessage("Invalid Confirm Pin");
              setOpenSnackbar(true);
            }}
          />
        )}
      </PremiumPageLayout>

      <PrintComponent>
        <WorksheetImportDownload
          surveyData={surveyData}
          formContent={formContent}
        />
      </PrintComponent>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={handleCloseSnackbar}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <MuiAlert
          elevation={6}
          variant="filled"
          severity={snackbarMessage?.includes("successful") ? "success" : "error"}
          onClose={handleCloseSnackbar}
        >
          {snackbarMessage}
        </MuiAlert>
      </Snackbar>

      {isShare && (
        <ShareWithClientsModal
          open={isShare}
          onClose={() => setIsShare(false)}
          onSuccess={(emails) => shareWithClient(emails)}
        />
      )}

      <LoadingModal open={open} handleClose={handleClose} />
    </>
  );
};
export default WorksheetImportPage;
